import React, { Fragment,useContext,useState } from "react";
import DataTable from "react-data-table-component";
import { DropdownItem } from "reactstrap";
import ActionOptions from "../Common/Component/ActionOptions";
import moment from "moment";
import { Spinner } from "../../AbstractElements";
// import DeleteConfirmation from "./DeleteConfirmation";
import CustomizerContext from "../../_helper/Customizer";
import { zoneColumns } from "../../Data/Configuration/Zone";
import DeleteConfirmation from "./DeleteConfirmation";

const ZoneTable = ({
    tableData,
    setShowApiLoader,
    fetchTableData,
    paginationPerPage,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    onEditClick,
    loader,
    editId,
    setEditId
}) => {
    const [deleteModal, setDeleteModal] = useState(false);
    const toggleDeleteModal = () =>
        setDeleteModal(!deleteModal);
    const [deleteObj,setDeleteObj] = useState({})

    const {mix_background_layout} = useContext(CustomizerContext)


    const conditionalRowStyles = [

        {
          when: row => row["Deleted"] ,
          style: row => ({ backgroundColor: row["Deleted"] ? "#F9B5A6" : ""}),
        },
      ];

    const processData = tableData.map((element, index) => {
        return {
            area: element.area ? element.area : "-",
            zone: element.zone ? element.zone : "-",
            serviceCityName: element.serviceCityName ? element.serviceCityName : "-",
            isAvailable: element.isAvailable ? "true" : "false",
            Deleted: element.isDeleted ,
            action: (
                <ActionOptions key={index}>
                    <Fragment>
                        <DropdownItem
                            className="border-0"
                            key={"row-edit"}
                            onClick={() => onEditClick(element)}
                        >
                            <i className="fa fa-pencil"></i> Edit
                        </DropdownItem>
                        <DropdownItem
                            className="border-0"
                            key={"row-edit"}
                            onClick={() => {
                                setDeleteObj(element)
                                toggleDeleteModal()
                            }}
                        >
                            <i className="fa fa-trash-o"></i> {element.isDeleted ? "Recover" : "Delete"}
                        </DropdownItem>
                    </Fragment>
                </ActionOptions>
            ),
        };
    });
    return (
        <Fragment>
            <div className="table-responsive corporate-client-table">
                <DataTable
                    columns={zoneColumns}
                    data={processData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={"57vh"}
                    pagination
                    paginationPerPage={paginationPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    // customStyles={customStyles}
                    conditionalRowStyles={conditionalRowStyles}
                    paginationServer
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>
            <DeleteConfirmation
                LargeModaltoggle={toggleDeleteModal}
                title={"Delete"}
                Large={deleteModal}
                deleteObj={deleteObj}
                fetchData={fetchTableData}
            />

        </Fragment>
    );
};

export default ZoneTable;
